import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useRef, useState } from 'react';
import { Delete, Edit } from '@mui/icons-material';
import { useSnackbar } from '../SnackBar';
import { IconButton } from '@mui/material';


export default function ProductCategoryView({ productCategory, onAddOrUpdate, onDeleteProductCategory }) {
    const { showSnackbar } = useSnackbar();
    const formRefs = useRef([]);
    const productCatRef = useRef(null);
    const navigate = useNavigate();
    const [editId, setEditId] = useState(null);
    const isEditing = editId !== null;

    const columns = [
        { field: 'name', headerName: 'Product Category', width: 250 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <>
                    <IconButton
                        color="primary"
                        onClick={() => handleItemEditClick(params.row)} // Pass the row
                    >
                        <Edit />
                    </IconButton>
                    <IconButton
                        color="secondary"
                        onClick={() => handleItemDeleteClick(params.row.id)} // Pass the id
                    >
                        <Delete />
                    </IconButton>
                </>
            )
        },

    ];

    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 5 });
    const handlePaginationChange = (newPaginationModel) => {
        setPaginationModel(newPaginationModel);
    };
    const CustomToolbar = (props) => (
        <GridToolbarContainer>
            <EditToolbar {...props} />
            <GridToolbar />
        </GridToolbarContainer>
    );

    const filterColumns = ({ field, columns, currentFilters }) => {
        // remove already filtered fields from list of columns
        const filteredFields = currentFilters?.map((item) => item.field);
        return columns
            .filter(
                (colDef) =>
                    colDef.filterable &&
                    (colDef.field === field || !filteredFields.includes(colDef.field)),
            )
            .map((column) => column.field);
    };

    const getColumnForNewFilter = ({ currentFilters, columns }) => {
        const filteredFields = currentFilters?.map(({ field }) => field);
        const columnForNewFilter = columns
            .filter(
                (colDef) => colDef.filterable && !filteredFields.includes(colDef.field),
            )
            .find((colDef) => colDef.filterOperators?.length);
        return columnForNewFilter?.field ?? null;
    };

    const handleItemDeleteClick = async (id) => {
        const result = await onDeleteProductCategory(id);
        if (result?.status === 200) {
            showSnackbar('Product Category deleted successfully!', 'success');
        } else {
            showSnackbar('Something went wrong.', 'error');
        }
    };
    function handleItemEditClick(category) {
        productCatRef.current.value = category.name;
        setEditId(category.id);
    };

    const handleUpdateClick = async () => {
        if (productCatRef.current.value.trim() === '') {
            handleClick();
            showSnackbar('Name cannot be blank', 'error');
            return;
        }
        const result = await onAddOrUpdate({ id: editId, name: productCatRef.current.value.trim() });
        if (result?.status === 200) {
            showSnackbar('Product Category Updated successfully!', 'success');
        } else {
            showSnackbar('Something went wrong.', 'error');
        }
    };


    const handleSaveClick = async () => {
        if (productCatRef.current.value.trim() === '') {
            handleClick();
            showSnackbar('Name cannot be blank', 'error');
            return;
        }
        const result = await onAddOrUpdate({ id: 0, name: productCatRef.current.value.trim() });
        if (result?.status === 200) {
            showSnackbar('Product Category saved successfully!', 'success');
        } else {
            showSnackbar('Something went wrong.', 'error');
        }
    };

    const handleClick = () => {
        const formElements = formRefs.current.elements;
        for (let element of formElements) {
            if (element.tagName === 'INPUT' && element.type !== 'button') {
                if (element.value === "") {
                    element.style.borderColor = 'red';
                } else {
                    element.style.borderColor = '';
                }
            }
        }
    };

    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;
        const handleClick = () => {
            setEditId(null);
            productCatRef.current.value = '';
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    New Product Category
                </Button>
            </GridToolbarContainer>
        );
    }

    const emptyCheck = (e) => {
        if (e.target.value === "") {
            e.target.style.borderColor = '';
        } else {
            e.target.style.borderColor = '';
        }
    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Branch</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="/productcategory">Product Category</a></li>

                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title"></h5>
                                <Box sx={{ width: '100%' }}>
                                    <AppBar position="static" color="default">
                                    </AppBar>
                                </Box>
                                <div style={{ height: '100%', width: '100%' }}>
                                    <form ref={formRefs}>
                                        <label className="col-form-label mb-2">Product Category</label>
                                        <div className="row align-items-center mb-3">
                                            <div className="col-sm-7">
                                                <input
                                                    type="text"
                                                    ref={productCatRef}
                                                    className="form-control"
                                                    placeholder="Please enter product category"
                                                    onBlur={(e) => emptyCheck(e)}
                                                />
                                            </div>
                                            <div className="col-sm-3">
                                                <button
                                                    type="button"
                                                    onClick={isEditing ? handleUpdateClick : handleSaveClick}
                                                    className="btn blue-button w-100"
                                                >
                                                    {isEditing ? 'Update' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                    {/*
                                    <TableContainer component={Paper}>
                                        <Table aria-label="additional service table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><strong>Product Categories</strong></TableCell>
                                                    <TableCell align="right"><strong>Actions</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {productCategory.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan={2} align="center">
                                                            <Typography variant="body1">No Product Categories available.</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {productCategory.map((cat) => (
                                                    <TableRow key={cat.id}>
                                                        <TableCell>{cat.name}</TableCell>
                                                        <TableCell align="right">
                                                            <IconButton
                                                                color="primary"
                                                                onClick={() => handleItemEditClick(cat)}>
                                                                <Edit />
                                                            </IconButton>
                                                            <IconButton
                                                                color="secondary"
                                                                onClick={() => handleItemDeleteClick(cat.id)} // Trigger delete confirmation for this brand
                                                            >
                                                                <Delete />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer> 
                                    */}

                                    <div style={{ height: '100%', width: '100%' }}>
                                        <DataGrid rows={productCategory} columns={columns}
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={handlePaginationChange}
                                            pageSizeOptions={[5, 10, 25]} // Customize page size options
                                            slots={{ toolbar: CustomToolbar }}
                                            slotProps={{
                                                filterPanel: {
                                                    filterFormProps: {
                                                        filterColumns,
                                                    },
                                                    getColumnForNewFilter,
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>
        </main>
    );
}
